import React, { useEffect, useState } from "react";
import SizingProgramTabel from "../../components/SizingProgramTabel";
import { Grid, Section, BreadCrumbBox, Loading } from "../../core";
import { getAllProgramsByCompany } from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";

const SizingProgram = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      const companyId = getCompanyId();
      if (!companyId) return;
      setIsLoading(true);
      try {
        const { data } = await getAllProgramsByCompany(companyId);
        setRows(Array.isArray(data) ? data : []);
      } catch (error) {
        console.log("sizing program error", error);
        setRows([]);
      }
      setIsLoading(false);
    };
    load();
  }, []);

  return (
    <Grid>
      <BreadCrumbBox tittle="Sizing Program" />
      <Section padding="20px">
        {isLoading ? <Loading /> : null}
        <SizingProgramTabel SizingProgramData={rows} />
      </Section>
    </Grid>
  );
};
export default SizingProgram;
